module.exports = __webpack_public_path__ + "static/media/document-menu.eb95b1c6.svg";